
export enum RuleSortableColumn {
    NAME = "name",
    CATEGORY_1 = "left_category_name",
    CATEGORY_2 = "right_category_name",
    TYPE = "rule_type",
    CREATED_ON = "created_at",
    UPDATED_BY = "updated_by_username",
    COMMIT = "commit",
    LAST_UPDATED = "updated_at"
}

export enum SortType {
    ASC = "ASC",
    DESC = "DESC"
}